// extracted by mini-css-extract-plugin
module.exports = {"gradient":"ServiceHero_gradient__4dK3M","heading":"ServiceHero_heading__kd99B","subheading":"ServiceHero_subheading__s1Tfe"};